export function checkProperties(obj) {
  for (const key in obj) {
    if (obj[key] === '') return false;
  }
  return true;
}

export const removeFormikLocalStorageKeys = () => {
  for (const key in localStorage) {
    if (key.includes('persistent')) {
      localStorage.removeItem(key);
    }
  }
};

export const removeEditFormStateKeys = () => {
  for (const key in localStorage) {
    if (key.includes('editMode')) {
      localStorage.removeItem(key);
    } else if (key.includes('picked')) {
      localStorage.removeItem(key);
    } else if (key.includes('persistent')) {
      localStorage.removeItem(key);
    } else if (key.includes('detailOpen')) {
      localStorage.removeItem(key);
    }
  }
};
